import { store } from "store";

export const getProfile = () => {
  return store.getState().auth.profile;
}

export const hasProfile = () => {
  return !!store.getState().auth.profile;
}

export const isAuthenticated = () => {
  return store.getState().auth.authenticated;
}
